import { ReactNode, useEffect, useState } from 'react'

type ClientPageProps = {
  children: ReactNode
}

export function ClientPage({ children }: ClientPageProps) {
  const [isClientSide, setIsClientSide] = useState(false)

  useEffect(() => {
    setIsClientSide(true)
  }, [isClientSide])

  return isClientSide ? <>{children}</> : null
}
